import React from "react"

const SelectTermBox = (props) => (
  <div
  className="col-md-3">
    <form>
      <label>
        Focused Terms:
        <div>
          <select size="5" style={{width:"100%"}} onChange={props.handleChange}>
            <option value="disciplinarity">disciplinarity</option>
            <option value="game">game</option>
            <option value="identity">identity</option>
            <option value="multimodality">multimodality</option>
            <option value="pedagogy">pedagogy</option>
            <option value="process">process</option>
            <option value="product">product</option>
            <option value="theory">theory</option>
          </select>
        </div>
      </label>
    </form>
  </div>
)

export default SelectTermBox
